// app/redux/actions/attestationsActions.js

// ===================== PARAMETRAGE (déjà chez toi) =====================
export const FETCH_ATTESTATIONS_REQUEST = "FETCH_ATTESTATIONS_REQUEST";
export const FETCH_ATTESTATIONS_SUCCESS = "FETCH_ATTESTATIONS_SUCCESS";
export const FETCH_ATTESTATIONS_FAIL = "FETCH_ATTESTATIONS_FAIL";

export const CREATE_ATTESTATION_REQUEST = "CREATE_ATTESTATION_REQUEST";
export const CREATE_ATTESTATION_SUCCESS = "CREATE_ATTESTATION_SUCCESS";
export const CREATE_ATTESTATION_FAIL = "CREATE_ATTESTATION_FAIL";

export const UPDATE_ATTESTATION_REQUEST = "UPDATE_ATTESTATION_REQUEST";
export const UPDATE_ATTESTATION_SUCCESS = "UPDATE_ATTESTATION_SUCCESS";
export const UPDATE_ATTESTATION_FAIL = "UPDATE_ATTESTATION_FAIL";

export const DELETE_ATTESTATION_REQUEST = "DELETE_ATTESTATION_REQUEST";
export const DELETE_ATTESTATION_SUCCESS = "DELETE_ATTESTATION_SUCCESS";
export const DELETE_ATTESTATION_FAIL = "DELETE_ATTESTATION_FAIL";

// ===================== WORKFLOW DEMANDES (nouveau) =====================
export const GET_MY_ATTESTATION_REQUESTS_REQUEST = "GET_MY_ATTESTATION_REQUESTS_REQUEST";
export const GET_MY_ATTESTATION_REQUESTS_SUCCESS = "GET_MY_ATTESTATION_REQUESTS_SUCCESS";
export const GET_MY_ATTESTATION_REQUESTS_FAIL = "GET_MY_ATTESTATION_REQUESTS_FAIL";

export const CREATE_ATTESTATION_REQUEST_REQUEST = "CREATE_ATTESTATION_REQUEST_REQUEST";
export const CREATE_ATTESTATION_REQUEST_SUCCESS = "CREATE_ATTESTATION_REQUEST_SUCCESS";
export const CREATE_ATTESTATION_REQUEST_FAIL = "CREATE_ATTESTATION_REQUEST_FAIL";

export const GET_MANAGER_ATTESTATION_INBOX_REQUEST = "GET_MANAGER_ATTESTATION_INBOX_REQUEST";
export const GET_MANAGER_ATTESTATION_INBOX_SUCCESS = "GET_MANAGER_ATTESTATION_INBOX_SUCCESS";
export const GET_MANAGER_ATTESTATION_INBOX_FAIL = "GET_MANAGER_ATTESTATION_INBOX_FAIL";

export const MANAGER_ATTESTATION_DECISION_REQUEST = "MANAGER_ATTESTATION_DECISION_REQUEST";
export const MANAGER_ATTESTATION_DECISION_SUCCESS = "MANAGER_ATTESTATION_DECISION_SUCCESS";
export const MANAGER_ATTESTATION_DECISION_FAIL = "MANAGER_ATTESTATION_DECISION_FAIL";

export const GET_ADMIN_ATTESTATION_INBOX_REQUEST = "GET_ADMIN_ATTESTATION_INBOX_REQUEST";
export const GET_ADMIN_ATTESTATION_INBOX_SUCCESS = "GET_ADMIN_ATTESTATION_INBOX_SUCCESS";
export const GET_ADMIN_ATTESTATION_INBOX_FAIL = "GET_ADMIN_ATTESTATION_INBOX_FAIL";

export const ADMIN_ATTESTATION_DECISION_REQUEST = "ADMIN_ATTESTATION_DECISION_REQUEST";
export const ADMIN_ATTESTATION_DECISION_SUCCESS = "ADMIN_ATTESTATION_DECISION_SUCCESS";
export const ADMIN_ATTESTATION_DECISION_FAIL = "ADMIN_ATTESTATION_DECISION_FAIL";

// ===================== DOWNLOAD (endpoint only) =====================
export const DOWNLOAD_ATTESTATION_PDF_REQUEST = "DOWNLOAD_ATTESTATION_PDF_REQUEST";
export const DOWNLOAD_ATTESTATION_PDF_SUCCESS = "DOWNLOAD_ATTESTATION_PDF_SUCCESS";
export const DOWNLOAD_ATTESTATION_PDF_FAIL = "DOWNLOAD_ATTESTATION_PDF_FAIL";

export const DOWNLOAD_ATTESTATION_REQUEST_PDF_REQUEST = "DOWNLOAD_ATTESTATION_REQUEST_PDF_REQUEST";
export const DOWNLOAD_ATTESTATION_REQUEST_PDF_SUCCESS = "DOWNLOAD_ATTESTATION_REQUEST_PDF_SUCCESS";
export const DOWNLOAD_ATTESTATION_REQUEST_PDF_FAIL = "DOWNLOAD_ATTESTATION_REQUEST_PDF_FAIL";

// ===================== UI =====================
export const SET_ATTESTATIONS_LOADING = "SET_ATTESTATIONS_LOADING";
export const CLEAR_ATTESTATIONS_MESSAGE = "CLEAR_ATTESTATIONS_MESSAGE";

// --------- helpers ----------
export const setAttestationsLoading = (v) => ({ type: SET_ATTESTATIONS_LOADING, payload: !!v });
export const clearAttestationsMessage = () => ({ type: CLEAR_ATTESTATIONS_MESSAGE });

// --------- parametrage ----------
export const fetchAttestationsRequest = () => ({ type: FETCH_ATTESTATIONS_REQUEST });
export const fetchAttestationsSuccess = (data) => ({ type: FETCH_ATTESTATIONS_SUCCESS, payload: data });
export const fetchAttestationsFail = (err) => ({ type: FETCH_ATTESTATIONS_FAIL, payload: err });


export const createAttestationRequest = (payload) => ({ type: CREATE_ATTESTATION_REQUEST, payload });
export const createAttestationSuccess = (created) => ({ type: CREATE_ATTESTATION_SUCCESS, payload: created });
export const createAttestationFail = (error) => ({ type: CREATE_ATTESTATION_FAIL, payload: error });


export const updateAttestationRequest = (payload) => ({ type: UPDATE_ATTESTATION_REQUEST, payload });
export const updateAttestationSuccess = (data) => ({ type: UPDATE_ATTESTATION_SUCCESS, payload: data });
export const updateAttestationFail = (err) => ({ type: UPDATE_ATTESTATION_FAIL, payload: err });

export const deleteAttestationRequest = (id) => ({ type: DELETE_ATTESTATION_REQUEST, payload: id });
export const deleteAttestationSuccess = (id) => ({ type: DELETE_ATTESTATION_SUCCESS, payload: id });
export const deleteAttestationFail = (err) => ({ type: DELETE_ATTESTATION_FAIL, payload: err });

// --------- workflow demandes ----------
export const getMyAttestationRequestsRequest = () => ({ type: GET_MY_ATTESTATION_REQUESTS_REQUEST });
export const getMyAttestationRequestsSuccess = (data) => ({ type: GET_MY_ATTESTATION_REQUESTS_SUCCESS, payload: data });
export const getMyAttestationRequestsFail = (err) => ({ type: GET_MY_ATTESTATION_REQUESTS_FAIL, payload: err });

export const createAttestationRequestRequest = (payload) => ({ type: CREATE_ATTESTATION_REQUEST_REQUEST, payload });
export const createAttestationRequestSuccess = (data) => ({ type: CREATE_ATTESTATION_REQUEST_SUCCESS, payload: data });
export const createAttestationRequestFail = (err) => ({ type: CREATE_ATTESTATION_REQUEST_FAIL, payload: err });

export const getManagerAttestationInboxRequest = () => ({ type: GET_MANAGER_ATTESTATION_INBOX_REQUEST });
export const getManagerAttestationInboxSuccess = (data) => ({ type: GET_MANAGER_ATTESTATION_INBOX_SUCCESS, payload: data });
export const getManagerAttestationInboxFail = (err) => ({ type: GET_MANAGER_ATTESTATION_INBOX_FAIL, payload: err });

export const managerAttestationDecisionRequest = (payload) => ({ type: MANAGER_ATTESTATION_DECISION_REQUEST, payload });
export const managerAttestationDecisionSuccess = (data) => ({ type: MANAGER_ATTESTATION_DECISION_SUCCESS, payload: data });
export const managerAttestationDecisionFail = (err) => ({ type: MANAGER_ATTESTATION_DECISION_FAIL, payload: err });

export const getAdminAttestationInboxRequest = () => ({ type: GET_ADMIN_ATTESTATION_INBOX_REQUEST });
export const getAdminAttestationInboxSuccess = (data) => ({ type: GET_ADMIN_ATTESTATION_INBOX_SUCCESS, payload: data });
export const getAdminAttestationInboxFail = (err) => ({ type: GET_ADMIN_ATTESTATION_INBOX_FAIL, payload: err });

export const adminAttestationDecisionRequest = (payload) => ({ type: ADMIN_ATTESTATION_DECISION_REQUEST, payload });
export const adminAttestationDecisionSuccess = (data) => ({ type: ADMIN_ATTESTATION_DECISION_SUCCESS, payload: data });
export const adminAttestationDecisionFail = (err) => ({ type: ADMIN_ATTESTATION_DECISION_FAIL, payload: err });

// --------- download ----------
export const downloadAttestationPdfRequest = (payload) => ({ type: DOWNLOAD_ATTESTATION_PDF_REQUEST, payload });
// payload: { attestationId, filename? }
export const downloadAttestationPdfSuccess = (data) => ({ type: DOWNLOAD_ATTESTATION_PDF_SUCCESS, payload: data });
export const downloadAttestationPdfFail = (err) => ({ type: DOWNLOAD_ATTESTATION_PDF_FAIL, payload: err });

export const downloadAttestationRequestPdfRequest = (payload) => ({ type: DOWNLOAD_ATTESTATION_REQUEST_PDF_REQUEST, payload });
// payload: { requestId, filename? }
export const downloadAttestationRequestPdfSuccess = (data) => ({ type: DOWNLOAD_ATTESTATION_REQUEST_PDF_SUCCESS, payload: data });
export const downloadAttestationRequestPdfFail = (err) => ({ type: DOWNLOAD_ATTESTATION_REQUEST_PDF_FAIL, payload: err });
